export default __webpack_public_path__ + "static/media/third-left-img-2x.46ad0cba.png";